import React from 'react';

function PendingCountBadge({ count }) {
  if (count === undefined || count === null) {
    return null;
  }

  // Display including 0 (badge format)
  return (
    <span className="pending-count-badge">{count}</span>
  );
}

export default PendingCountBadge;

